import { JstDate } from '../../../core/time/business-time';
export type MemberStatusChange = 0 | 1 | 2 | 3;
export interface MemberStatusTarget { readonly memberId: number; readonly studioId: number; readonly currentStatus: number; readonly remove: boolean; }
export interface MemberStatusCommand { readonly status: MemberStatusChange; readonly expulsionReason: string; }
export type StatusPhase = 'checking' | 'saving' | 'history' | 'refreshing' | 'failed' | 'unknown' | 'partial' | 'saved-stale' | 'saved';
export interface MemberStatusOperation {
  readonly owner: number;
  readonly studioId: number;
  readonly memberId: number;
  readonly status: MemberStatusChange;
  readonly phase: StatusPhase;
  readonly memberConfirmed: boolean;
  readonly historyConfirmed: boolean;
  readonly message: string;
}
export function statusBusy(operation?: MemberStatusOperation): boolean {
  return !!operation && ['checking', 'saving', 'history', 'refreshing'].includes(operation.phase);
}
export function statusBlocked(operation?: MemberStatusOperation): boolean {
  return !!operation && operation.phase !== 'failed' && operation.phase !== 'saved';
}
export function statusCommandValid(target: MemberStatusTarget, command: MemberStatusCommand, role: number): boolean {
  if (!Number.isInteger(target.memberId) || target.memberId <= 0 || !Number.isInteger(target.studioId) || target.studioId <= 0) return false;
  if (target.remove) return target.currentStatus === 1 && command.status === 3 && role <= 10;
  if (target.currentStatus === 0) return command.status === 1 || command.status === 2 && !!command.expulsionReason.trim();
  return [1, 2].includes(target.currentStatus) && command.status === 0;
}
export function statusUpdateBody(memberId: number, command: MemberStatusCommand, now: Date): object {
  if (command.status === 1) return { id: memberId, status: 1, disabledAt: now };
  if (command.status === 2) return { id: memberId, status: 2, expulsionReason: command.expulsionReason, expelledAt: now };
  return { id: memberId, status: 0 };
}
export function historyEndDate(now: Date): Date { now = new JstDate(now); return new JstDate(now.getFullYear(), now.getMonth(), now.getDate()); }
